<mat-card class="filter settingHeader">
  <div class="name">
    Manage System Prompts
  </div>

  <div class="quickAction">    
      <!-- <mat-form-field class="example-form-field" appearence="fill">
        <mat-label>Search Category</mat-label>
        <input matInput type="text"  readonly  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button> -->
      <!-- </mat-form-field> -->
        
        <div class="">      
          <button mat-flat-button color="primary" (click)="openDialogAdd(addmyDialog)"> Add System Prompts </button>   
        </div>
     
  </div>
</mat-card>

<div class="documents">

<mat-card class="example-list rowholder">
  <div class="fieldRow head">
    <span class="moveicon"></span>
    <span class="fieldName">Prompt Title</span>
    <span class="fieldName">Prompt Type</span>
    <!-- <span class="requried">Active/Inactive</span> -->
    <span class="editField">Edit</span>
    <span class="delete">Delete</span>
  </div>

  <div class="example-box fieldRow" *ngFor="let type of sysPromptList">
    <span class="moveicon"></span>

    <!-- Title -->
    <span class="fieldName">{{ type.systemPromptTitle }}</span>

    <!-- Type Name -->
    <span class="fieldName">{{ type.promptName }}</span>

    <!-- Edit -->
    <span class="editField">
      <button
        mat-icon-button
        class="editbtn"
        (click)="openDialogUpdateType(addmyDialog, type)"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </span>

    <!-- Delete -->
    <span class="delete">
      <button
        mat-icon-button
        class="trash"
        (click)="DeleteSystemPrompt(type)"
      >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </span>
  </div>
</mat-card>

    <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</div>


<ng-template #addmyDialog>

  <h2 mat-dialog-title>
     {{title}}
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
    <mat-label>Prompt Title</mat-label>
    <input matInput maxlength="500" [required]="true"  
    placeholder="Add Prompt Title"  [(ngModel)]="promptTitle"
     />   
</mat-form-field>
 <mat-form-field class="example-full-width">
      <mat-label>Prompt Type</mat-label>
      <mat-select [(ngModel)]="promptType" name="promptType" required>
        <mat-option [value]="0">Normal</mat-option>
        <mat-option [value]="1">Allergy</mat-option>
        <mat-option [value]="2">Medication</mat-option>
        <mat-option [value]="3">Condition</mat-option>
        <mat-option [value]="4">Immunization</mat-option>
        <mat-option [value]="5">Observation</mat-option>
        <mat-option [value]="6">NTA</mat-option>
        <mat-option [value]="7">Nursing</mat-option>
      </mat-select>
    </mat-form-field>

  <mat-form-field class="example-full-width">
      <mat-label>System Prompt</mat-label>
      <!-- <input matInput maxlength="100" [required]="true"  
       placeholder="Add System Prompt"  [(ngModel)]="systemPrompt"
        />    -->
        <textarea matInput placeholder="Add System Prompt" [required]="true"   id="ntatxtarea" [(ngModel)]="systemPrompt"  style="width:98%;height:380px;"></textarea>
       
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary"  [disabled]="AddEditButton" 
  (click)="AddUpdateSystemPrompts()">
    {{button}}
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
</ng-template>


<app-loader></app-loader>

<style>
  .cke_notifications_area { display: none;}
</style>


<style>
  .cke_notification { display: none; }
</style>
<style>
  .cke_notification_warning { display: none; }
</style>